export const formValidation = {
  methods: {
    validateState(form,field) {
      const resolve = (a, b) => {
        return b.split('.').reduce((o,k) => o?.[k], a)
      }
      try {
        const { $dirty, $error } = field !== undefined ? resolve(this.$v[form], field) : this.$v[form];
        return $dirty ? !$error : null;
      } catch (e) {
        return null;
      }
    },
  }
}
